import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CustomMatSvgIconDirective } from '@pct-ng/icon';
import { MatIcon } from '@angular/material/icon';
import type { TableCellComponent } from '../table-cell/table-cell.component';
import type { TrueFalseCellParameters } from './true-false-cell-parameters';

@Component({
  selector: 'pct-feature-table-material-true-false-cell',
  imports: [MatIcon, CustomMatSvgIconDirective],
  template: `@let parameters = params();
    <mat-icon [customMatSvgIcon]="value() ? parameters.trueIcon : parameters.falseIcon" /> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrueFalseCellComponent<T> implements TableCellComponent<
  T,
  boolean,
  TrueFalseCellParameters
> {
  readonly rowItem = input.required<T>();
  readonly value = input.required<boolean>();
  readonly params = input.required<TrueFalseCellParameters>();
}
